import { ticoticketApi } from "../ticoticketApi";

export const getUpcomingEvents = async () => {
  try {
    const { data } = await ticoticketApi.get("/events");
    return { ok: true, upcomingEvents: data };
  } catch (error: any) {
    console.log(error.response.data);
    return {
      ok: false,
      errorMessage: error.response.data,
    };
  }
};

export const getCategoryWithEvents = async (categoryId: string) => {
  try {
    const { data } = await ticoticketApi.get(`/events?category=${categoryId}`);
    return { ok: true, categoryWithEvents: data };
  } catch (error: any) {
    console.log(error.response.data);
    return {
      ok: false,
      errorMessage: error.response.data,
    };
  }
};

export const getCategories = async () => {
  try {
    const { data } = await ticoticketApi.get(`/events/categories`);
    return { ok: true, categories: data };
  } catch (error: any) {
    console.log(error.response.data);
    return {
      ok: false,
      errorMessage: error.response.data,
    };
  }
};

export const getFeaturedEvents = async () => {
  try {
    const { data } = await ticoticketApi.get("/events/featuredevents");
    return { ok: true, featuredEvents: data };
  } catch (error: any) {
    console.log(error.response.data);
    return {
      ok: false,
      errorMessage: error.response.data,
    };
  }
};

export const getEventById = async (id: number) => {
  try {
    const { data } = await ticoticketApi.get(`/events/${id}`);
    return { ok: true, eventDataById: data };
  } catch (error: any) {
    console.log(error.response.data);
    return {
      ok: false,
      errorMessage: error.response.data,
    };
  }
};
